import { useMutationBuilder } from "../useBuilders";
import { USER } from "../queryKeys";
import { usersApi } from "src/services/settings/users";
import { useInfiniteQueryBuilder, useQueryBuilder } from "../useBuilders";
import { USERS } from "../queryKeys";

export const useNotifyUser = () => {
  return useMutationBuilder([USER, 'NOTIFY'], usersApi.notifyUser);
}

export const useUsersFetch = (query: string) => {
  return useInfiniteQueryBuilder(
    [USERS],
    ({ pageParam = 0 }) => usersApi.fetchUsers(query, pageParam),
    0,
    (response) => {
      const nextPage = (response?.totalPages > response?.currentPage + 1) ? response?.currentPage + 1 : undefined;
      return nextPage;
    }
  );
};

export const useUserManagementStatusFetch = () => {
  return useQueryBuilder([USERS, 'STATUS'], usersApi.fetchUserManagementStatus, false, 0, true);
};
